import axios from "axios";
import { PositionsInfo } from "../contexts/AuthContext";

const baseUrl = "https://api.vidaverify.ir:31300/api";
// const baseUrl = "https://api.vidaverify.ir:44440/api";
const authToken =
  "Bearer eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJTQU5BT1BFUkFUT1IiLCJuYmYiOjE2NDA5Nzk3NjQsImV4cCI6MTY3MjUxNTc2NCwiaWF0IjoxNjQwOTgwNzkxfQ.GtdY44r9u2aYZkbmdd18_MMAfp6s5gik8YFLxpxAsxQo5lbfYjMyc7qHa8gT0oari3J_LjHWHmq94kFFj5ocGA";


export const checkTokenRequest = (
  token: string,
  returnUrl: string,
  requestNo: string,
  deviceType: string
) => {
  const formData = new FormData();
  formData.append("token", token);
  formData.append("requestNo", requestNo);
  formData.append("returnUrl", returnUrl);
  formData.append("deviceType", deviceType);
  return axios.post(`${baseUrl}/sana`, formData, {
    headers: {
      Authorization: authToken,
      "Access-Control-Allow-Origin": "*",
    },
  });
};


export const getRandomRequest = (
  uniqueId: string,
) => {
  // const formData = new FormData();
  // formData.append("uniqueId", uniqueId);
  return axios.get(`${baseUrl}/sana/random`, {
    headers: {
      Authorization: authToken,
    },
    params: {
      uniqueId
    }
  });
};



export const sanaVerifyRequest = (
  selfieVideo: File,
  signature: File,
  selfieImg: File,
  livenessTools: string,
  token: string,
  returnUrl: string,
  requestNo: string,
  uniqueId: string,
  position: PositionsInfo | null,
  locationIp: string,
  officeCode: string | '',
  onUploadProgress: (p: any) => void = () => { }
) => {
  const formData = new FormData();
  formData.append("token", token);
  formData.append("requestNo", requestNo);
  formData.append("returnUrl", returnUrl);
  formData.append("signature", signature);
  formData.append("livenessTools", livenessTools);
  formData.append("selfieVideo", selfieVideo);
  formData.append("selfieImg", selfieImg);
  formData.append("uniqueId", uniqueId);
  formData.append("position", JSON.stringify(position));
  formData.append("locationIp", locationIp);
  formData.append("officeCode", officeCode);
  return axios.post(`${baseUrl}/sana/auth`, formData, {
    headers: {
      Authorization: authToken,
    },
    timeout: 3 * 60 * 1000,
    onUploadProgress,
  });
};
